<template>
  <div class="flex flex-col">
    <div class="py-[10px] flex justify-between font-caption-1">
      <span>{{ $t("appliedFilters.allArticles") }}</span>
      <span>{{ $t("appliedFilters.onlyHighRelevance") }}</span>
    </div>
    <SliderInput
      data-intercom-target="Article Relevance slider"
      :current-value="value"
      :max-value="3"
      :on-change="update"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useSearchFiltersStore } from "~/store/searchFilter";
import SliderInput from "~/components/shared/SliderInput.vue";

const searchFilterStore = useSearchFiltersStore();
const emit = defineEmits(["performUpdate"]);

const value = computed(() => {
  // Translate the GCH value (0-6) into stepped values for the slider (0-3)
  const storeVal = Math.floor(
    searchFilterStore?.currentSearchFilter?.filter_relevance / 2,
  );
  return [0, 1, 2, 3].includes(storeVal) ? storeVal : 1;
});

const update = (value: number) => {
  searchFilterStore.updateRelevance(Number(value));
  emit("performUpdate");
};
</script>
